module.exports = __webpack_public_path__ + "img/push_icon.0bec2e29.svg";